type props = {
  onSave?: any;
  disable?: boolean;
};

const SwitchBarButton: React.FC<props> = ({ onSave, disable }): JSX.Element => (
  <div className="w-full">
    <button
      className={`h-6 w-full rounded-full px-2 text-center text-sm text-white ${
        disable ? 'pointer-events-none cursor-not-allowed bg-gray-300' : 'stacked-bar-blue-400'
      }`}
      onClick={onSave}
      disabled={disable}
    >
      SAVE
    </button>
  </div>
);

export default SwitchBarButton;
